import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from './Elements';
import { FormInput, TextField } from './Inputs';

import createLogger from '../../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `CreateLeadModal.js`);

class CreateLead extends React.Component {

  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);
    debug.enter(`constructor`);

    this.state = {
      company_url: ``,
      agency_url: ``,
      title: ``,
    }
  }

  componentWillUnmount() {
    this.clearState();
  }

  /* ------------ private helpers ------------ */
  clearState = () => this.setState({
    company_url: ``,
    agency_url: ``,
    title: ``,
  });

  /* ------------ event handlers ------------ */
  onCancel = () => {
    this.clearState();
    this.props.onCancel();
  };

  onInputChange = (field) => (input) => {
    this.setState({[field]: input});
  };

  onSubmit = () => {
    const { onSubmit } = this.props;
    const { title,
      company_url,
      agency_url,
    } = this.state;

    if (company_url &&
        agency_url &&
        title) {
      onSubmit(title, company_url, agency_url);
    }
  };

  /* ------------ render methods ------------ */
  render() {
    const {
      onInputChange,
      onSubmit,
      onCancel,
    } = this;
    const {
      company_url,
      agency_url,
      title,
    } = this.state;

    debug.enter(`render`);

    const formConfig = {
      className: `create-lead`,
    };

    const fieldConfigs = {
      title: {
        value: title,
        name: `create-lead-title`,
        label: `Job Title`,
        onChange: onInputChange(`title`),
        placeholder: `Enter job title...`,
      },
      companyURL: {
        value: company_url,
        name: `create-lead-company-url`,
        label: `Hiring Company Posting URL`,
        onChange: onInputChange(`company_url`),
        placeholder: `Paste company's job posting URL`,
      },
      agencyURL: {
        value: agency_url,
        name: `create-lead-agency-url`,
        label: `Source Agency Posting URL`,
        onChange: onInputChange(`agency_url`),
        placeholder: `Paste agency's job posting URL`,
      }
    };

    const canSubmit = (!!title && title !== `` && title.trim() !== ``) &&
      (!!company_url && company_url !== `` && company_url.trim() !== ``) &&
      (!!agency_url && agency_url !== `` && agency_url.trim() !== ``);

    return (
      <div className="create-lead">
        <FormInput {...formConfig}>
          <TextField {...fieldConfigs.title}/>
          <TextField {...fieldConfigs.companyURL}/>
          <TextField {...fieldConfigs.agencyURL}/>
        </FormInput>
        <footer>
          <Button onClick={onCancel}
                  type="theme-light">
            Cancel
          </Button>
          <Button type="submit"
                  onClick={onSubmit}
                  disabled={!canSubmit}>
            Create
          </Button>
        </footer>
      </div>
    );
  }
}

export default CreateLead;



// WEBPACK FOOTER //
// ./src/components/static/CreateLead.js